{/* EC-676 - Date Range field Reducer for order history listing */}

// Importing utility to create a typed reducer using Immer for immutable state management
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

// Importing Immer's Draft type for state mutability in reducers
import { Draft } from "immer";

// Interface defining the state structure for date range validation in order history
export interface OrderHistoryDateRangeValidatorState {
    // Error message for invalid 'From Date'
    fromDateError: string;

    // Error message for invalid 'To Date'
    toDateError: string;
}

// Initial state for the date range validator, with default empty error messages
const initialState: OrderHistoryDateRangeValidatorState = {
    fromDateError: "", // Default no error for 'From Date'
    toDateError: "",   // Default no error for 'To Date'
};

// Reducer object containing action handlers for managing date validation errors
const OrderHistoryDateRangeValidatorReducer = {
    // Action to set error messages for 'From Date' and 'To Date'
    "Custom/OrderHistory/DateValidator/SetDateError": (
        draft: Draft<OrderHistoryDateRangeValidatorState>, // Draft state for mutability
        action: {
            data: OrderHistoryDateRangeValidatorState; // Action payload containing new error messages
        },
    ) => {
        // Update the draft state with new error messages
        draft.fromDateError = action.data.fromDateError;
        draft.toDateError = action.data.toDateError;
    },
};

// Exporting the reducer created with Immer for handling immutable state
export default createTypedReducerWithImmer(initialState, OrderHistoryDateRangeValidatorReducer);

{/* EC-676 - Date Range field Reducer for order history listing */}
